function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "plus-o-thick");

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, React.createElement("g", {
  id: "Outline_Old_Icons",
  "data-name": "Outline Old Icons"
}, React.createElement("path", {
  d: "M7.75,0A7.75,7.75,0,1,0,15.5,7.75,7.76,7.76,0,0,0,7.75,0Zm0,14A6.25,6.25,0,1,1,14,7.75,6.25,6.25,0,0,1,7.75,14ZM11.8,7.75a.76.76,0,0,1-.75.75H8.5v2.55a.75.75,0,0,1-1.5,0V8.5H4.45a.75.75,0,1,1,0-1.5H7V4.45a.75.75,0,1,1,1.5,0V7h2.55A.76.76,0,0,1,11.8,7.75Z"
})));

var SvgPlusCircleThick = function SvgPlusCircleThick(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 15.5 15.5",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgPlusCircleThick, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/plus-circle-thick.d7dbfa92.svg";
export { ForwardRef as ReactComponent };